module.exports = __webpack_public_path__ + "img/wireless.59221414.png";